import { GET_GROUPING } from '../../../columns/grouping.store';

export function getExtraTableWidth(): number {
  return 0;
}
